import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { message } from 'antd';

interface ApiCall {
  queryKey: string;
  queryFn: (params: any) => Promise<any>;
}

interface PostApiOptions {
  resourceName?: string;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

// Replacement for usePostApi
export function usePostApi<TData = any, TVariables = any>(
  apiCall: ApiCall,
  options?: PostApiOptions
) {
  const { resourceName = 'item', onSuccess, onError } = options || {};

  const mutation = useMutation({
    mutationFn: async (params: TVariables) => {
      const response = await apiCall.queryFn(params);
      return response;
    },
    onSuccess: data => {
      if (onSuccess) {
        onSuccess(data);
      }
    },
    onError: (error: any) => {
      if (onError) {
        onError(error);
      }
    },
  });

  return {
    post: mutation.mutate,
    postAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
    rawData: mutation.data,
    reset: mutation.reset,
  };
}
